import React, { useState, useEffect, useRef, useContext } from "react";
import { useLocation, useHistory } from "react-router-dom";
import {
  Grid,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import axios from "axios";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import Cookies from "js-cookie";
import Feed from "../feed";
import PhotoPreview from "../../PhotoPreview";
import TrendingTags from "../trendingTags";
import SayAskPost from "./sayAskPost";
import useStyles from "./styles";
import styles from "./ViewActBeforeSignIn.module.css";
import API from "src/network";
import SearchResultBeforeLogin from "./SearchResultBeforeSignup";
import RightSide from "./RightSide";
import Page from "src/layout/Page";
import { SignupContext } from "src/context/SignupContext/SignupContext";
import _ from "lodash";
import UserAddSvg from "src/Components/UserAddSvg";
import { useSelector } from "react-redux";
import { CommunityContext } from "src/context/CommunityContext/CommunityContext";
import style from "src/Assets/css/home/Feed.module.css";

const ViewActivityBeforeIn = () => {
  const {
    buttonContainer,
    feed,
    container,
    moderator,
    prospectimagesdiv,
    invitebutton,
    filterinput,
    roundcontent,
    asksayNav,
    askHoverImage,
    askSelectedImage,
    sayHoverImage,
    saySelectedImage,
    updateSelectedImage,
    updateHoverImage,
    tagHoverImage,
    tagSelectedImage,
    comunityProfileArrowIcon,
    loader,
    backDefaultCommunityBtn,
  } = useStyles();
  const imageServerURL = process.env.REACT_APP_SKOPIC_IMAGE_OTHER;
  const baseURL = process.env.REACT_APP_SERVICES_API_OTHER;
  const location = useLocation();
  const history = useHistory();

  const [images, setImages] = useState({});
  const [selectedImage, setSelectedImage] = useState({});
  const [contributors, setContributors] = useState({});
  const [communityData, setCommunityData] = useState({});
  const [selectedId, setSelectedId] = useState("");
  const [feedData, setFeedData] = useState([]);
  const [previewModal, setPreviewModal] = useState(false);
  const [contentType, setContentType] = useState("feed");
  const [isAskData, setIsAskData] = useState([]);
  const [isAskTempData, setIsAskTempData] = useState([]);
  const [isTagData, setIsTagData] = useState([]);
  const [isTagTempData, setIsTagTempData] = useState([]);
  const [page, setPage] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const listRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [childSayLoading, setChildSayLoading] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [saysId, setSaysId] = useState("");
  const [childSaysData, setChildSaysData] = useState([]);
  const [contributorBio, setContributorBio] = useState({});
  const [showBio, setShowBio] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [isEnable, setIsEnable] = useState(null);
  const [isSignIn, setIsSignIn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [searchData, setSearchData] = useState({});
  const [clearSearchHeader, setClearSearchHeader] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [distFromTop, setDistFromTop] = React.useState("0px");

  const signupContext = useContext(SignupContext);
  const communityContext = useContext(CommunityContext);

  const { defaultCountry } = location.state || {};

  const userDetails = useSelector((state) => state?.SignInReducer?.userDetails);

  useEffect(() => {
    setIsEnable(location?.state?.signIn);
  }, [location]);

  console.log(`selectedImage:`, selectedImage);
  console.log(`communityTenantId:`, location?.state?.tenantId);

  useEffect(() => {
    const tenantId = location?.state?.tenantId;
    const isInvalidTenantId = tenantId === undefined || isNaN(Number(tenantId));

    if (isInvalidTenantId) {
      setOpenDialog(true);
    } else {
      setOpenDialog(false);
    }
  }, [location?.state?.tenantId]); // runs on every change

  const handleRedirect = () => {
    setOpenDialog(false);
    history.push("/defaultCommunity");
  };

  useEffect(() => {
    // The purpose of this useEffect is to show a warning to the user if they try
    // to refresh the page during the signup process, specifically when they haven't
    // completed the community selection. If the user refreshes the page unnecessarily,
    // the signup flow will break, and they won't be able to complete the signup process.
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue =
        "Warning: If you refresh the page, you will lose your signup progress and any entered data. Please choose a default community to complete the signup process instead of refreshing.";
    };

    // Add the event listener
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const onHashTagClick = (hashTag) => {
    return;
  };

  console.log(`selectedFilter:`, selectedId);

  const makeDefaultHandlerForBlockedCommunity = async () => {
    const data = new FormData();
    data.append("userDefaultTenantId", location?.state?.tenantId);
    const res = await API.updateDefaultTenant(data);
    if (res?.data?.status === "Community updated successfully") {
      communityContext?.onChangeCommunity({
        tenantId: location?.state?.tenantId,
        tenantName: location?.state?.community,
      });
      Cookies.set("signInStatus", true);
      history.push("/Home");
    }
  };

  const fetchSearchData = async (params) => {
    setContentType("search");
    setLoading(true);
    setSearchParam(params);
    try {
      const response = await API.getSearchData(params);
      setSearchData(response.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleMakeDefault = () => {
    if (
      userDetails?.userData?.communityStatus === "communityBlocked" ||
      userDetails?.userData?.currentCommunityStatus == 0
    ) {
      makeDefaultHandlerForBlockedCommunity();
    } else {
      //set signup context data
      signupContext?.setSignupState({
        community: location?.state?.community,
        tenantId: location?.state?.tenantId,
      });

      //go back to home screen
      history.push("/");
    }
  };

  const fetchApi = async () => {
    setLoading(true);
    await axios
      .request({
        url: `${baseURL}/jsonindex/community-url?src=inviteLink&tid=${
          location?.state?.tenantId
        }&id=${"Z2Vmb3lpNDMzOEBmcmFuZGluLmNvbQ=="}`,
        method: "Get",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Set-Cookie": Cookies.get("JSESSIONID"),
        },
        withCredentials: true,
      })
      .then((res) => {
        setCommunityData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // fetchApi();
    console.log("location->", location);
  }, [location]);

  // useEffect(() => {
  //   console.log(`communityData:`, communityData);
  //   if (communityData) {
  //     console.log("inside", communityData);
  //     setTimeout(() => {
  //       fetchParamApi();
  //       fetchFeedApi();
  //       fetchContributeApi();
  //       fetchAskApi();
  //       fetchTagsApi();
  //     }, 1000);
  //   }
  // }, [communityData]);

  useEffect(() => {
    if (communityData) {
      console.log("inside", communityData);
      setTimeout(() => {
        fetchParamApi();
        fetchFeedApi("");
        fetchContributeApi();
        fetchAskApi();
        fetchTagsApi();
      }, 1000);
    }
  }, [communityData]);

  const fetchContributeApi = async () => {
    try {
      const res = await API.fetchContributors();
      setContributors(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchParamApi = async () => {
    await axios
      .get(`${baseURL}/jsonindex/main?logParam=restrict`)
      .then((res) => {
        setImages(res?.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 3000);
      });
  };

  const fetchFeedApi = async (filtertype) => {
    try {
      setLoading(true);
      const url = filtertype
        ? `${baseURL}/jsonmessage/all-feed?filtertype=${filtertype}&startlimit=${page}&limiter=all`
        : `${baseURL}/jsonmessage/all-feed?startlimit=${page}&limiter=all`;
      const res = await axios.get(url, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Set-Cookie": Cookies.get("JSESSIONID"),
        },
        withCredentials: true,
      });
      const newList = res?.data?.feed || [];
      setFeedData([...newList]);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const fetchAskApi = async () => {
    await axios
      .request({
        url: `${baseURL}/jsonmessage/trending-items?task=asks&more=all&breadCountLength=${page}`,
        method: "post",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Set-Cookie": Cookies.get("JSESSIONID"),
        },
        withCredentials: true,
      })
      .then((res) => {
        const trendingAsks = res?.data?.trendingAsks || [];
        const newList = [...trendingAsks];
        setIsAskData(newList);
        setIsAskTempData(newList?.slice(0, 2));
      });
  };

  const fetchTagsApi = async () => {
    await axios
      .request({
        url: `${baseURL}/jsonmessage/trending-items?task=tags&more=all&breadCountLength=${page}`,
        method: "post",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Set-Cookie": Cookies.get("JSESSIONID"),
        },
        withCredentials: true,
      })
      .then((res) => {
        const trendingTags = res?.data?.trendingTags || [];
        const newList = [...trendingTags];
        setIsTagData(newList);
        setIsTagTempData(newList?.slice(0, 2));
      });
  };

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = listRef.current;
    if (scrollTop + clientHeight === scrollHeight) {
      setIsFetching(true);
      setIsClicked(true);
      setPage(page + 10);
    }
  };

  // useEffect(() => {
  //   if (isFetching) {
  //     feedData?.length === 10 && fetchFeedApi();
  //     isAskData?.length === 10 && fetchAskApi();
  //     isTagData?.length === 10 && fetchTagsApi();
  //   }
  // }, [isFetching, page]);

  useEffect(() => {
    const obj = images?.communities?.find(
      (item) => item?.id === location?.state?.tenantId,
    );
    setSelectedImage(obj);
  }, [images]);

  // useEffect(() => {
  //   if (selectedId) {
  //     fetchFeedApi();
  //   } else {
  //     fetchFeedApi();
  //   }
  // }, [selectedId]);

  useEffect(() => {
    fetchFeedApi(selectedId);
  }, [selectedId]);

  const handleClick = (id) => {
    // setIsClicked(true);
    setPage(0);
    setSaysId("");
    if (selectedId === id) {
      setSelectedId("");
    } else {
      setSelectedId(id);
    }
  };

  const showPreview = (e) => {
    setPreviewModal(!previewModal);
  };

  const handleSeeAll = (id) => {
    setContentType(id);
    setSelectedId("");
  };

  const handleBack = () => {
    setContentType("feed");
    setPage(0);
    fetchAskApi();
    fetchTagsApi();
    setClearSearchHeader(true);
  };

  const handleBackArrow = () => {
    history.push("/defaultCommunity", {
      community: location?.state?.community,
      tenantId: location?.state?.tenantId,
      email: location?.state?.email,
      password: location?.state?.password,
      displayName: location?.state?.displayName,
      previousCountry: defaultCountry,
    });
  };

  const handleSayClick = async (e, id) => {
    e.preventDefault();
    if (saysId === id) {
      setSaysId("");
    } else {
      setSaysId(id);
      try {
        setChildSayLoading(true);
        let formdata = new FormData();
        formdata.append("id", id);
        formdata.append("in_pop_columns", "all");
        formdata.append("in_limit", 0);
        const res = await axios.post(
          `${baseURL}/jsonuser/child-says`,
          formdata,
        );
        setChildSaysData(res?.data);
      } catch (e) {
        console.error(e);
      } finally {
        setChildSayLoading(false);
      }
    }
  };

  const fetchChildSaysData = async (id) => {
    try {
      setChildSayLoading(true);
      let formdata = new FormData();
      formdata.append("id", id);
      formdata.append("in_pop_columns", "all");
      formdata.append("in_limit", 0);
      const res = await axios.post(`${baseURL}/jsonuser/child-says`, formdata);
      setChildSaysData(res?.data);
    } catch (e) {
      console.error(e);
    } finally {
      setChildSayLoading(false);
    }
  };

  const [pointerLeft, setPointerLeft] = React.useState("12px");
  const hideTimerRef = useRef(null);

  const handleClickEvent = (id, showBio, targetElOrDist) => {
    if (!showBio || !targetElOrDist) {
      scheduleHide();
      return;
    }

    cancelHide();

    const data = contributors?.contribut?.find((item) => {
      return item?.id === id;
    });
    setContributorBio(data);
    setShowBio(true);

    if (typeof targetElOrDist === "string") {
      setDistFromTop(targetElOrDist);
      return;
    }

    if (
      targetElOrDist &&
      typeof targetElOrDist.getBoundingClientRect === "function"
    ) {
      const rect = targetElOrDist.getBoundingClientRect();
      const sidebarEl =
        document.querySelector('[class*="RightSide"]') ||
        document.querySelector('[class*="rightSidebar"]') ||
        targetElOrDist.closest(".col-lg-3");
      const sidebarRect = sidebarEl?.getBoundingClientRect();

      const top = rect.bottom - (sidebarRect?.top ?? 0) + 4;
      setDistFromTop(`${top}px`);

      // horizontal center of avatar relative to bio card's left edge
      const bioCardLeft =
        (sidebarRect?.left ?? 0) + (sidebarRect?.width ?? 0) * 0.1; // matches `left: 10%`
      const avatarCenter = rect.left + rect.width / 2;
      const pointer = avatarCenter - bioCardLeft - 8; // 8 = half of pointer width
      setPointerLeft(`${Math.max(12, pointer)}px`);
    }
  };

  const cancelHide = () => {
    if (hideTimerRef.current) {
      clearTimeout(hideTimerRef.current);
      hideTimerRef.current = null;
    }
  };

  const scheduleHide = () => {
    hideTimerRef.current = setTimeout(() => {
      setShowBio(false);
    }, 400);
  };

  const onModalSelect = () => {
    setModalShow(false);
  };

  const handleFollowunfollow = (id, status) => {
    console.log("dd", id, status);
  };

  return (
    <Page
      fetchSearchData={fetchSearchData}
      clearSearchHeader={clearSearchHeader}
      isMenuActionDisabled={true}
      flow="beforeSignIn"
      pageType={"viewActivity"}
      hideSearch
      onClickHashTag={onHashTagClick}
    >
      {isLoading ? (
        <CircularProgress className={loader} />
      ) : (
        <React.Fragment>
          <div className="container">
            <div
              className={`row ${styles.rowContainer}`}
              style={{ marginBottom: "100px" }}
            >
              <div className={`col-lg-9 ${styles.leftside}`}>
                {contentType === "search" ? (
                  <SearchResultBeforeLogin
                    childSaysData={childSaysData}
                    fetchChildSaysData={fetchChildSaysData}
                    loading={loading}
                    searchData={searchData}
                    handleBack={handleBack}
                    isActionDisabled={true}
                    flow="beforeSignIn"
                    onHashTagClick={onHashTagClick}
                  />
                ) : contentType === "feed" ? (
                  <>
                    <div
                      className={style.feed}
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                      }}
                      // onClick={(e) => showPreview(e)}
                    >
                      <img
                        src={
                          selectedImage?.logo
                            ? `${imageServerURL}${selectedImage?.logo}`
                            : process.env.REACT_APP_DUMMY_COMMUNITY_IMAGE
                        }
                        alt="Tenant Logo"
                        className={style.backgroundImage}
                        onClick={(e) => showPreview(e)}
                      />
                      <div className={container}>
                        {selectedImage ? (
                          <div className={moderator}>
                            <p
                              onClick={(e) => showPreview(e)}
                              style={{
                                fontSize: "20px",
                                color: "#373334",
                                margin: 0,
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "90%",
                              }}
                            >
                              {selectedImage?.name}
                            </p>
                            <MdOutlineArrowForwardIos
                              className={comunityProfileArrowIcon}
                              onClick={(e) => showPreview(e)}
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        ) : (
                          <div className={moderator}>{null}</div>
                        )}

                        <div className={prospectimagesdiv}>
                          <a
                            className={invitebutton}
                            style={{ cursor: "not-allowed" }}
                          >
                            <UserAddSvg />
                            Invite Members
                          </a>
                        </div>
                      </div>
                      <PhotoPreview
                        open={previewModal}
                        handleClose={() => setPreviewModal(false)}
                        tenantId={location?.state?.tenantId}
                        communityImage={selectedImage?.logo}
                        communityDescription={selectedImage?.description}
                        communityName={selectedImage?.name}
                        tenantlatitude={selectedImage?.tenantlatitude}
                        tenantlongitude={selectedImage?.tenantlongitude}
                        communityAddress={""}
                      />
                    </div>
                    <div>
                      <div className={filterinput}>
                        <SayAskPost
                          isSignIn={isSignIn}
                          isEnable={isEnable}
                          isActionDisabled={true}
                          onHashTagClick={onHashTagClick}
                        />
                        <div className={roundcontent}>
                          <div className={asksayNav}>
                            <ul>
                              <li
                                onClick={() => handleClick("ask")}
                                className={
                                  selectedId === "ask"
                                    ? askHoverImage
                                    : askSelectedImage
                                }
                              >
                                <a>
                                  <span>Ask</span>
                                </a>
                              </li>
                              <li
                                onClick={() => handleClick("say")}
                                className={
                                  selectedId === "say"
                                    ? sayHoverImage
                                    : saySelectedImage
                                }
                              >
                                <a>
                                  <span>Say</span>
                                </a>
                              </li>
                              <li
                                onClick={() => handleClick("update")}
                                className={
                                  selectedId === "update"
                                    ? updateHoverImage
                                    : updateSelectedImage
                                }
                              >
                                <a>
                                  <span>Update</span>
                                </a>
                              </li>
                              <li
                                onClick={() => handleClick("hashtag")}
                                className={
                                  selectedId === "hashtag"
                                    ? tagHoverImage
                                    : tagSelectedImage
                                }
                              >
                                <a>
                                  <span>Tag</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          background: "#E5E4E2",
                          border: "1px solid #DEE0E1",
                          borderRadius: "20px 0 0 0",
                          padding: "10px 20px 0 20px",
                          height: "calc(100vh - 90px)",
                          overflowY: "scroll",
                        }}
                        onScroll={handleScroll}
                        ref={listRef}
                      >
                        <Feed
                          feedLoading={loading}
                          data={feedData}
                          handleSayClick={handleSayClick}
                          id={saysId}
                          childSaysData={childSaysData}
                          handleFollowunfollow={handleFollowunfollow}
                          childSayLoading={childSayLoading}
                          isActionDisabled={true}
                          flow="beforeSignIn"
                          onHashTagClick={onHashTagClick}
                          filterType={selectedId}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <TrendingTags
                    data={contentType === "asks" ? isAskData : isTagData}
                    handleBack={handleBack}
                    isAsksClicked={contentType}
                    handleSayClick={handleSayClick}
                    id={saysId}
                    childSaysData={childSaysData}
                    handleFollowunfollow={handleFollowunfollow}
                    isLoading={childSayLoading}
                    isActionDisabled={true}
                    flow="beforeSignIn"
                    onHashTagClick={onHashTagClick}
                  />
                )}
              </div>

              <div className={`col-lg-3 ${styles.rightside}`}>
                <RightSide
                  contributors={contributors}
                  handleClickEvent={handleClickEvent}
                  contributorBio={contributorBio}
                  showBio={showBio}
                  isSignIn={isSignIn}
                  isEnable={isEnable}
                  isTagTempData={isTagTempData}
                  isAskTempData={isAskTempData}
                  handleSeeAll={handleSeeAll}
                  pageType={"viewActivityBeforeSignIn"}
                  distFromTop={distFromTop}
                  pointerLeft={pointerLeft}
                  cancelHide={cancelHide}
                  scheduleHide={scheduleHide}
                />
              </div>
            </div>
          </div>

          <Grid
            container
            style={{
              padding: "10px",
              background: "#4795DE",
              position: "fixed",
              bottom: 0,
              zIndex: 1,
            }}
          >
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "16px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              <div
                onClick={handleBackArrow}
                className={backDefaultCommunityBtn}
              >
                <ArrowCircleLeftIcon style={{ fill: "#ffffff" }} />
              </div>
              Choose a Default Community to continue with Sign Up process
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "10px",
              }}
            >
              <div className={buttonContainer} style={{ display: "flex" }}>
                <Button variant="contained" onClick={handleMakeDefault}>
                  Make Default
                </Button>
              </div>
            </Grid>
          </Grid>
          <Dialog open={openDialog} onClose={handleRedirect}>
            <DialogTitle>Community Activity Access</DialogTitle>
            <DialogContent>
              <p>
                To view the activity of any community, first go to the{" "}
                <strong>Community List</strong>, then click the{" "}
                <strong>View Activity</strong> button of your desired community
                based on country.
              </p>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleRedirect}
                color="primary"
                variant="contained"
              >
                Go to Community List
              </Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      )}
    </Page>
  );
};

export default ViewActivityBeforeIn;
